import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import api from '../../axiosConfig'



const TransactionsTwo = () => {

 
  const [xmls, setXmls] = useState(0);
  const [cfdis, setCfdis] = useState(0);
  const [recibos, setRecibos] = useState(0);


  useEffect(() => {

    fetchNotificaciones();

  }, []);


  const fetchNotificaciones = async () => {
    try {
      const res = await api.get(`/dashboard/admin/archivos`);
      if (res.status === 200) {
        setXmls(res.data.XMLS)
        setCfdis(res.data.CFDIS)
        setRecibos(res.data.RECIBOS)
      }
    } catch (e) {
      //setErr("No se pudieron cargar las notificaciones.");
    } finally {
    }
  };


  return (
    <div className='col-xxl-4'>
      <div className='card h-100'>
        <div className='card-body p-24'>
          <div className='d-flex align-items-center flex-wrap gap-2 justify-content-between'>
            <h6 className='mb-2 fw-bold text-lg'>Numero de archivos</h6>

          </div>
          <div className='mt-32'>
            <div className='d-flex align-items-center justify-content-between gap-3 mb-24'>
              <div className='d-flex align-items-center gap-3'>
                <div className='w-40-px h-40-px rounded-circle d-flex justify-content-center align-items-center bg-success-200 flex-shrink-0'>
                  <Icon icon='mage:box' className='menu-icon' />
                </div>
                <div className='flex-grow-1'>
                  <h6 className='text-md mb-0 fw-normal'>CFDIS</h6>

                </div>
              </div>
              <span className='text-secondary-light text-md fw-medium'>
                {cfdis}
              </span>
            </div>
            <div className='d-flex align-items-center justify-content-between gap-3 mb-24'>
              <div className='d-flex align-items-center gap-3'>
                <div className='w-40-px h-40-px rounded-circle d-flex justify-content-center align-items-center bg-info-200 flex-shrink-0'>
                  <Icon icon='mage:box' className='menu-icon' />
                </div>
                <div className='flex-grow-1'>
                  <h6 className='text-md mb-0 fw-normal'>XMLS</h6>

                </div>
              </div>
              <span className='text-secondary-light text-md fw-medium'>
                {xmls}
              </span>
            </div>
            <div className='d-flex align-items-center justify-content-between gap-3 mb-24'>
              <div className='d-flex align-items-center gap-3'>
                <div className='w-40-px h-40-px rounded-circle d-flex justify-content-center align-items-center bg-warning-200 flex-shrink-0'>
                  <Icon icon='mage:box' className='menu-icon' />
                </div>
                <div className='flex-grow-1'>
                  <h6 className='text-md mb-0 fw-normal'>Recibos </h6>

                </div>
              </div>
              <span className='text-secondary-light text-md fw-medium'>
                {recibos}
              </span>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionsTwo;
